import { i18next, utils } from '@yola/ws-sdk';

const validateCanonicalUrl = (value) => {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return null;
  }

  const hasHttpProtocol = /^(https?:\/\/)/i.test(normalizedValue);
  if (!hasHttpProtocol) {
    return i18next.t('Start with https:// or http://');
  }

  if (!utils.validation.isFullyURL(normalizedValue)) {
    return i18next.t('Please enter valid URL');
  }

  return null;
};

export default validateCanonicalUrl;
